import React, { Component } from "react";
import { API_BASE_URL } from "../../constants";
import { request } from "../../util/APIUtils";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import Table from "../../components/Table/Table";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import MeetingForm from "./MeetingForm";
import FileModal from "./FileModal";
import ParticipantModel from "./ParticipantModel";
import {Button, Dropdown, Icon, Menu, notification} from "antd";



class MeetingList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            add: false,
            meetings: [],
            listMeeting: [],
            selectedMeeting: null,
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            currentPage: 1,
            manual: false,
            participants: null,
            addMeetingModal: false,
            updateMeetingModal:false,
            addParticipantsModel: false,
            currentMeeting: null,
            addFileModal: false,
            mode: "edit",
            memberInfo: {
                fotoPath: "",
                fotoFile: null,
                fotoThumbFile: null,
                fieldsDisabled: false,
            },
            deleteMeetingModal: false,
            itemToBeDeleted: null
        };

        this.listMeetings = this.listMeetings.bind(this);
        this.cancelMeetingCreation = this.cancelMeetingCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);


    }
    componentDidMount() {
        this.listMeetings();
    }

    listMeetings(accessor = "toplantiTarihi", direction = "desc", page = 0, size = 10) {
        let self = this;
        let q = self.state.searchQuery;
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let sortStr = "&sort=" + accessor + ',' + direction;
        let queryString = self.state.searching ? '?' + q : '';
        let params = {
            url: `${API_BASE_URL}/allMeets?page=${page}&size=${size}${searchQuery}${sortStr}`,
            method: "get",
        };
        self.setState({ loading: true, searching: true });
        request(params)
            .then(function (response) {
                let totalChanged = false;
                if (response.data.totalElements !== self.state.total) {
                    totalChanged = true;
                }
                let listMeeting = response.data;
                self.setState({
                    listMeeting,
                    loading: false,
                    searching: false,
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    meetings: response.data.content,
                    totalIdList: response.data.content.map(listMeeting => listMeeting.id),
                    debtList: response.data.content.map(listMeeting => listMeeting.toplantiSaati),
                });
            }).catch(function (error) {
            self.setState({ loading: false, searching: false, error: "Toplantılar yüklenirken bir sorun oluştu." });
            showAxiosError(error);
        });
    }


    cancelMeetingCreation() {
        this.setState({
            addMeetingModal: false,
            selectedMeeting: null,
            addFileModal:false,
            addParticipantsModel: false,
            deleteMeetingModal:false,
        });
    }
    openFileModal(item) {
        this.setState({
            addFileModal: true,
            currentMeeting: item,
        });
    }

    openParticipantsModel(item) {
        console.log(item);
        this.setState({
            addParticipantsModel: true,
            participants: item.members
        });
    }
    handleFileUploadComplete = () => {
        this.setState({ addFileModal: false });
    }

    addNew() {
        this.setState({
            selectedMeeting: null,
            addMeetingModal: true,
            updateMeetingModal:true,
            addFileModal: false,
            mode: "create",
            add:true,
        });
    }


    handleSearch(searchQuery,fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.listMeetings(this.state.accessor, this.state.direction, page, this.state.size))
    }

    openUpdateMeetingModel = (item) => {
        this.setState({deleteMeetingModal: true, itemToBeDeleted: item})
    }
    handleEdit = (item) => {
        this.setState({
            selectedMeeting: item,
            addMeetingModal: true,
            mode: "edit",
        });
    }

    openDeleteMeetingModel = (item) => {
        this.setState({deleteMeetingModal: true, itemToBeDeleted: item})
    }

    handleDelete = (item) => {
        let self = this;
        let params = {
            url: API_BASE_URL + "/deleteMeeting/" + item.id,
            method: "delete",
        };
        request(params)
            .then(function (response) {
                self.listMeetings();
                self.setState({deleteMeetingModal: false})
                notification.success({
                    message: item.toplantiKonusu,
                    description: "Toplantı başarıyla silindi",
                    duration:30,
                });
            })
            .catch(function (error) {
                self.setState({deleteMeetingModal: false})
                showAxiosError(error);
            });
    }

    componentDidMount() {
        console.log("inside componentdidmount");
        this.listMeetings();
    }
    render() {
        const { meetings, loading } = this.state;
        const columns = [
            {
                Header: "Toplantı Konusu",
                accessor: "toplantiKonusu",
            },
            {
                Header: "Toplantı Tarihi",
                accessor: "toplantiTarihi",
                Cell: (item) => (
                    <label>{new Date(item.toplantiTarihi).toLocaleDateString("tr")}</label>
                ),
            },
            {
                Header: "Başlangıç Saati",
                accessor: "toplantiSaati",
            },
            {
                Header: "Bitiş Saati",
                accessor: "toplantiBitisSaati",
            },
            {
                Header: "Katılımcılar",
                accessor: "katilimcilar",
                sortable: false,
                Cell: (item) => (
                    <div className="textCenter">
                        <button
                            type="button"
                            onClick={() => this.openParticipantsModel(item)}
                            data-toggle="tooltip"data-placement="bottom" title="Katılımcılar"
                            style={{background:"linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))",}}
                            rel="tooltip" className="Btn btn-sm btn-icon">
                            <i className="fa fa-users"/>
                        </button>
                    </div>
                )
            },
            {
                Header: "Belgeler",
                accessor: "document_name",
            },
           /* {
                Header: "Belge Yükle",
                accessor: "",
                sortable: false,
                Cell: (item) => (
                    <div className="textCenter">
                        <button
                            type="button"
                            onClick={() => this.openFileModal(item)}
                            data-toggle="tooltip"data-placement="bottom" title="Belge yükle"
                            style={{background:"linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))",}}
                            rel="tooltip" className="Btn btn-sm btn-icon">
                            <i className="fa fa-edit"/>
                        </button>
                    </div>
                ),
            },*/

            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: (item) => (
                    <div className="textCenter">
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item key="edit" onClick={() => this.handleEdit(item)}>
                                        Toplantı Düzenle
                                    </Menu.Item>
                                    <Menu.Item key="delete" onClick={() => this.openDeleteMeetingModel(item)}>
                                        Toplantı Sil
                                    </Menu.Item>
                                    <Menu.Item key="delete" onClick={() => this.openFileModal(item)}>
                                        Belge Yükle
                                    </Menu.Item>
                                </Menu>
                            }
                            trigger={['click']}
                        >
                            <Button
                                style={{
                                    background: '#3b6b96',
                                    height: '30px',
                                    width: '100px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                    fontSize: "12px",
                                }}
                            >
                                Seçiniz <Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                ),
            },
        ];

        const fields = [
            {
                label: "Toplantı Konusu",
                accessor: "toplantiKonusu",
                type: "text",
                operator: "=",
            },
            {
                label: "Toplantı Tarihi",
                accessor: "toplantiTarihi",
                type: "date",
                operator: "=",
            },
            {
                label: "Toplantı Saati",
                accessor: "toplantiSaati",
                type: "text",
                operator: "=",
            },
            {
                label: "Toplantı Bitiş Saati",
                accessor: "toplantiBitisSaati",
                type: "text",
                operator: "=",
            },
        ];

        return (
            <div className="row baseBackground">
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Toplantı Düzenleme İşlemleri</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch
                                    fields={fields}
                                    loading={this.state.searching}
                                    onSearch={this.handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={this.state.meetings}
                            total={this.state.total}
                            page={this.state.page}
                            manual={this.state.manual}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.listMeetings}
                            style={{width:"100%"}}
                        />
                    </div>
                    <div className="new-button-holder">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Yeni Toplantı Ekle" disabled={this.state.isLoading}
                                style={{
                                    background: 'linear-gradient(#2b93cd, #0a66b7)',
                                    height: '40px',
                                    width: '180px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                }}
                                className="TekBtn add-new-member "
                                rel="tooltip"
                                onClick={() => this.addNew()}>
                            YENİ TOPLANTI EKLE
                        </button>
                    </div>
                </div>

                <Modal isOpen={this.state.addMeetingModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelMeetingCreation}>
                        {this.state.add ? 'Toplantı Ekleme ' : 'Toplantı Düzenleme '}
                    </ModalHeader>
                    <ModalBody style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>
                        <MeetingForm
                            cancelProcess={this.cancelMeetingCreation}
                            selectedMeeting={this.state.selectedMeeting}
                            userGroups={this.state.userGroups}
                            mode={this.state.mode}
                            handleSearch={this.handleSearch}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addFileModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelMeetingCreation}>
                        Dosya Yükle
                    </ModalHeader>
                    <ModalBody>
                        <FileModal
                            currentMeeting={this.state.currentMeeting}
                            memberInfo={this.state.memberInfo}
                            onFileUploadComplete={this.handleFileUploadComplete}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addParticipantsModel} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelMeetingCreation}>
                        Katılımcılar
                    </ModalHeader>
                    <ModalBody>
                        <ParticipantModel
                            participants={this.state.participants}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.deleteMeetingModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelMeetingCreation}>
                        Toplantıyı sil
                    </ModalHeader>
                    <ModalBody style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>
                        <h4>{this.state.itemToBeDeleted ? `"${this.state.itemToBeDeleted.toplantiKonusu}" silinecektir. Emin misiniz?` : null}</h4>

                        <div className="text-right" id="deleteModal">
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px',float: 'left', width:"150px"}}
                                    rel="tooltip" className="TekBtn vazgec " onClick={() => this.setState({deleteMeetingModal: false})}>
                                İptal
                            </button>

                            <button type="button"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"150px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    onClick={() => this.handleDelete(this.state.itemToBeDeleted)}>
                                Onayla
                            </button>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default MeetingList;


// WEBPACK FOOTER //
// ./src/page/odaList/MeetingList.js